<template>
  <v-container>
    <div class="d-flex justify-center ma-6" >
      <div><v-img src="@/assets/nexus-logo.png" max-width="50"></v-img></div>
      <div class="ml-6">
        <span class="text-h3">
          N E X U S
        </span>
      </div>
    </div>
    <v-card v-if="user && user.id">
      <v-card-title class="justify-center">
        <div>Reset Password</div>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
        <v-subheader class="my-4">
          Welcome {{ user.firstName }} {{ user.lastName }}, please reset your
          password for {{ user.accountName }}.
        </v-subheader>
        <div class="ma-4">
          <v-text-field
            tabindex="1"
            :rules="passwordRules"
            v-model="password"
            label="New Password"
            :append-icon="showPass1 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="() => (showPass1 = !showPass1)"
            :type="showPass1 ? 'text' : 'password'"
          ></v-text-field>
          <v-text-field
            tabindex="2"
            :rules="passwordConfirmRule"
            v-model="confirmPassword"
            label="Confirm New Password"
            :append-icon="showPass2 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="() => (showPass2 = !showPass2)"
            :type="showPass2 ? 'text' : 'password'"
          ></v-text-field>
        </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          tabindex="3"
          color="primary"
          class="mb-5"
          :disabled="isAppLoading"
          @click="resetPassword()"
          >Update</v-btn
        >
        <v-spacer />
      </v-card-actions>
    </v-card>
    <div v-else-if="loaded">
      <unauthorized />
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Unauthorized from "@/components/error/Unauthorized.vue";
import { rules } from "@/store/util/rules.js";

export default {
  components: { Unauthorized },
  data() {
    return {
      loaded: false,
      userToken: null,
      currentPassword: "",
      password: "",
      confirmPassword: "",
      user: null,
      showPass1: false,
      showPass2: false,
      passwordRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 6) || "Passowrd must be at least 6 characters"
      ],
      passwordConfirmRule: [
        () => this.password === this.confirmPassword || "Password must match"
      ],
      rules
    };
  },
  computed: {
    ...mapGetters("navigation", ["isAppLoading", "globalCenter"])
  },
  async mounted() {
    this.userToken = this.$route.query.token;
    this.user = await this.getUserWithToken(this.userToken);
    if(this.user){
      this.loaded = true;
    }
    else{ 
      this.loaded = false;
    }
  },
  methods: {
    ...mapActions('messages', ['addMessage', 'addSuccessMessage', 'addErrorMessage']),
    async getUserWithToken(token) {
      if (!token) {
        return null;
      }

      const params = {
        token
      };
      return await this.$axios
        .get("/public/user/user-by-token", { params })
        .then(resp => {
          const user = resp.data;
          return user;
        })
        .catch(() => {
          this.addErrorMessage("Invalid or expired token");
        });
    },
    resetPassword() {
      if (!this.$refs.form.validate()) {
        this.addErrorMessage("Please check your inputs");
        return;
      }

      if (this.userToken) {
        this.resetPwdWithToken();
      } else {
        this.authenticatedPwdReset();
      }
    },
    resetPwdWithToken() {
      const resetData = {
        token: this.userToken,
        confirmPassword: this.confirmPassword,
        currentPassword: this.currentPassword,
        password: this.password
      };

      this.$axios
        .post("/public/user/resetpwd", resetData)
        .then( () => {
          this.addSuccessMessage(`Your password has been updated`)
          this.$router.push({
            name: "Login",
            query: { account: this.user.accountId }
          });
        })
        .catch(error => {
          const message = error.data.message || "Error resetting your password";
          this.addErrorMessage(message);
        });
    },
    authenticatedPwdReset() {
      const data = {
        confirmPassword: this.confirmPassword,
        currentPassword: this.currentPassword,
        password: this.password
      };

      this.$axios
        .post("/user/reset-password", data)
        .then(resp => {
          const customerName = resp.data.firstName;
          this.addMessage(`${customerName}, your password has changed`);
          this.$router.push("/");
        })
        .catch(error => {
          const message = error.data.message || "Error resetting your password";
          this.addErrorMessage(message);
        });
    }
  }
};
</script>

<style></style>
